import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/HighlightOffOutlined';
import { AdminTestContext } from '@orientaction/Context';
import { cloneDeep } from 'lodash';
import { useContext, useMemo } from 'react';
import QuestionForm from '../QuestionForm';
import style from './style';

const QuestionDrawer = () => {
  const { test, updateTest } = useContext<any>(AdminTestContext);
  const classes = style();

  const idAglomeration = useMemo(() => {
    return test.idAglomerationSelected;
  }, [test.idAglomerationSelected]);

  const isEdit = test?.questionAglomerationToCreate?.type === 'edit';

  const handleClose = () => {
    updateTest({
      questionAglomerationDrawerOpen: false,
      questionAglomerationToCreate: undefined,
    });
  };

  const handleClick = () => {
    if (!test?.questionAglomerationToCreate?.title) {
      updateTest({
        questionAglomerationToCreate: {
          ...test.questionAglomerationToCreate,
          errors: {
            ...test?.questionAglomerationToCreate?.errors,
            title: true,
          },
        },
      });
      return;
    }

    if (
      test?.questionAglomerationToCreate?.mediaType !== 'none' &&
      !test?.questionAglomerationToCreate?.mediaUrl
    ) {
      updateTest({
        questionAglomerationToCreate: {
          ...test.questionAglomerationToCreate,
          errors: {
            ...test?.questionAglomerationToCreate?.errors,
            mediaUrl: true,
          },
        },
      });
      return;
    }

    if (!test?.questionAglomerationToCreate?.responses?.length) {
      updateTest({
        questionAglomerationToCreate: {
          ...test.questionAglomerationToCreate,
          errors: {
            ...test?.questionAglomerationToCreate?.errors,
            response: true,
          },
        },
      });
      return;
    }

    // Validation de l'image
    if (
      test?.questionAglomerationToCreate?.imageType === 'image' &&
      !test?.questionAglomerationToCreate?.image
    ) {
      updateTest({
        questionAglomerationToCreate: {
          ...test.questionAglomerationToCreate,
          errors: {
            ...test?.questionAglomerationToCreate?.errors,
            image: true,
          },
        },
      });
      return;
    }

    const { aglomerations } = test;
    const cloneAglomerations = cloneDeep([...aglomerations]);

    if (isEdit) {
      const index = cloneAglomerations[idAglomeration]?.questions?.findIndex(
        (q: any) => q.id === test.questionAglomerationToCreate.id
      );
      const firstSlice = cloneAglomerations[idAglomeration]?.questions.slice(0, index);
      const secondSlice = cloneAglomerations[idAglomeration]?.questions.slice(index + 1);
      cloneAglomerations[idAglomeration].questions = [
        ...firstSlice,
        { ...test.questionAglomerationToCreate },
        ...secondSlice,
      ];
      updateTest({
        questionAglomerationDrawerOpen: false,
        aglomerations: cloneAglomerations,
        questionAglomerationToCreate: undefined,
      });
    } else {
      // push created question into questions array
      cloneAglomerations[idAglomeration].questions.push({
        ...test.questionAglomerationToCreate,
        isNew: true,
      });
      updateTest({
        questionAglomerationDrawerOpen: false,
        aglomerations: cloneAglomerations,
        questionAglomerationToCreate: undefined,
      });
    }
  };

  return (
    <Drawer
      anchor="right"
      open={test.questionAglomerationDrawerOpen}
      classes={{ root: classes.rootStyle, paper: classes.drawerContent }}>
      <div className={classes.headerContainer}>
        <IconButton className={classes.closeBtn} onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
        <div className={classes.titleContainer}>
          <Typography variant="h3" className={classes.title}>
            {`${isEdit ? 'Modifier' : 'Ajouter'} une question`}
          </Typography>
        </div>
      </div>
      <div className={classes.contentChild}>
        <QuestionForm idAglomeration={idAglomeration} />
      </div>
      <div className={classes.footerWrapper}>
        <Button onClick={handleClick} className={classes.btnPrimary}>
          <span className={classes.textHeader}>Valider</span>
        </Button>
      </div>
    </Drawer>
  );
};

export default QuestionDrawer;
